// Copyright (c) 2017 Deere & Company

import * as helpers from './helpers';
import React, {
    PropTypes,
    PureComponent
} from 'react';
import DealerHierarchyLeadAccounts from './dealer-hierarchy-lead-accounts';

class DealerHierarchyTerritories extends PureComponent {

    handleAccountChange = selectedTerritory => accountChanges => {

        this.props.onAccountChange({
            ...accountChanges,
            selectedTerritory
        });

    };

    handleCityChange = selectedTerritory => cityChanges => {

        this.props.onCityChange({
            ...cityChanges,
            selectedTerritory
        });

    };

    handleLeadAccountChange = selectedTerritory => leadAccountChanges => {

        this.props.onLeadAccountChange({
            ...leadAccountChanges,
            selectedTerritory
        });

    };

    handleTerritoryChange = territory => () => {

        const selectedTerritory = territory.territory;
        const selectedTerritories = helpers.updateSelectionMap(this.props.selectedTerritories, selectedTerritory);

        this.props.onTerritoryChange({
            selectedTerritories,
            selectedTerritory,
            territory
        });

    };

    render() {

        return (
            <ul className='territories'>
                {this.props.territories.map((territory, territoryIndex) =>
                    <li key={territoryIndex}>
                        <DealerHierarchyLeadAccounts
                            leadAccounts={territory.leadAccounts}
                            onAccountChange={this.handleAccountChange(territory.territory)}
                            onCityChange={this.handleCityChange(territory.territory)}
                            onLeadAccountChange={this.handleLeadAccountChange(territory.territory)}
                            selectedAccounts={this.props.selectedAccounts}
                            selectedCities={this.props.selectedCities}
                            selectedLeadAccounts={this.props.selectedLeadAccounts}
                            territoryIndex={territoryIndex}
                        />

                    </li>
                )}
            </ul>
        );

    }

}

DealerHierarchyTerritories.displayName = 'DealerHierarchyTerritories';
DealerHierarchyTerritories.propTypes = {
    onAccountChange: PropTypes.func.isRequired,
    onCityChange: PropTypes.func.isRequired,
    onLeadAccountChange: PropTypes.func.isRequired,
    onTerritoryChange: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.object.isRequired,
    selectedCities: PropTypes.object.isRequired,
    selectedLeadAccounts: PropTypes.object.isRequired,
    selectedTerritories: PropTypes.object.isRequired,
    territories: PropTypes.array.isRequired
};

export default DealerHierarchyTerritories;



// WEBPACK FOOTER //
// ./src/tcsm/audits/components/audit-dealer-hierarchy/dealer-hierarchy-territories.js